import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";
import { useT } from "../i18n/I18nContext";

export default function Login() {
  const { user, login } = useAuth();
  const t = useT();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/app" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) navigate("/app");
    else setError(r.error);
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md card-mabw p-8 md:p-10 anim-fade-up" data-testid="login-card">
        <div className="flex items-center gap-3 mb-2">
          <Logo size={40} />
          <span className="font-semibold" style={{ fontFamily: "Outfit" }}>MABW</span>
        </div>
        <h1 className="text-3xl font-semibold mt-4" style={{ fontFamily: "Outfit" }}>
          {t("auth.login_title")}
        </h1>
        <p className="text-sm text-mabw-soft mt-2">{t("auth.login_sub")}</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="text-sm font-medium" htmlFor="login-email">{t("auth.email")}</label>
            <input id="login-email" type="email" autoComplete="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-mabw mt-1.5" data-testid="login-email-input" />
          </div>
          <div>
            <label className="text-sm font-medium" htmlFor="login-password">{t("auth.password")}</label>
            <input id="login-password" type="password" autoComplete="current-password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-mabw mt-1.5" data-testid="login-password-input" />
          </div>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}
          <button type="submit" disabled={busy} className="btn-mabw w-full" data-testid="login-submit-btn">
            {busy ? t("auth.logging_in") : t("auth.login_btn")}
          </button>
        </form>

        <div className="mt-4 text-sm text-right">
          <Link to="/password-dimenticata" className="text-mabw-soft hover:text-mabw-primary" data-testid="login-forgot-link">
            {t("auth.forgot_link")}
          </Link>
        </div>

        <div className="mt-6 text-sm text-mabw-soft">
          {t("auth.no_account")}{" "}
          <Link to="/registrati" className="text-mabw-primary font-medium" data-testid="login-go-register">
            {t("auth.to_register")}
          </Link>
        </div>
      </div>
    </div>
  );
}
